let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aKQg5")).then(() => parcelRequire('36mBo'));